import { Button, Image, Progress, Typography, Upload, message } from "antd";
import { RcFile } from "antd/es/upload";
import { api } from "api";
import { T_Api_Success_Res } from "api/api.types";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { useState } from "react";
import { getDriveUrl } from "utils/functions";
import styles from "./FileUpload.module.scss";
import { TbEdit, TbPhoto, TbTrash, TbVideo } from "react-icons/tb";
import { imageFileTypes, videoFileTypes } from "./FileUpload.constants";
import { MediaDto } from "dtos/media.dto";

type T_UploadFile = {
  // filename: string;
  // originalname: string;
  // size: number;
  // path: string;
  // mimetype: string;
  fileId: string;
  fileSlug: string;
};

type T_FileUploadProps = {
  fileType?: "image" | "video";
  value?: string;
  onChange?: (val: string | undefined) => void;
  setDimension?: (height: number | undefined, width: number | undefined) => void;
};

export default function FileUpload({ fileType = "image", value, onChange, setDimension }: T_FileUploadProps) {
  const [progress, setProgress] = useState<number>();

  const beforeUpload = (file: RcFile) => {
    console.log(file);
    const isLt64M = file.size / 1024 / 1024 < 64;

    if (!isLt64M) {
      message.error("File must smaller than 64MB");
    }

    if (fileType === "image") {
      const isSupportedImageType = imageFileTypes.includes(file.type);
      if (!isSupportedImageType) {
        message.error("You can only upload JPG/PNG/SVG/WEBP file");
      }
      const img = new window.Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        img.onload = () => {
          const { width, height } = img;
          setDimension?.(height as number, width as number);
          console.log("Image width:", width, "Image height:", height);
        };
        img.src = e.target?.result as string;
      };
      reader.readAsDataURL(file);
      return isSupportedImageType && isLt64M;
    } else if (fileType.includes("video")) {
      const isSupportedVideoType = videoFileTypes.includes(file.type);
      if (!isSupportedVideoType) {
        message.error("You can only upload MP4/WEBM file");
      }
      return isSupportedVideoType && isLt64M;
    }
  };

  function handleUpload(file: string | Blob) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("isPublic", "true");

    const config: AxiosRequestConfig = {
      onUploadProgress: (event) => {
        if (event?.total) {
          const percent = Math.floor((event.loaded / event?.total) * 100);
          setProgress(percent);
        }
      },
    };
    // post request to the api
    api
      .post("/media", formData, config)
      .then((res: AxiosResponse<T_Api_Success_Res<MediaDto>>) => {
        // console.log(res.data);
        onChange?.(res?.data?.result?.url[0]);

        message.success("File upload successful");
        setTimeout(() => {
          setProgress(0);
        }, 500);
      })
      .catch(() => {
        message.error("File upload failed");
      });
  }

  const uploadButton = (
    <button className={styles.upload_btn} type="button">
      {typeof progress !== "undefined" ? (
        <Progress
          size={64}
          percent={progress}
          type="circle"
          format={() => {
            return fileType === "image" ? (
              <TbPhoto style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
            ) : (
              <TbVideo />
            );
          }}
        />
      ) : (
        <div className={styles.inner_content}>{fileType === "image" ? <TbPhoto /> : <TbVideo />}</div>
      )}

      <Typography.Text>
        Upload {fileType === "image" ? "an" : "a"} {fileType}
      </Typography.Text>
      <Typography.Text type="secondary">File size should be under 64MB</Typography.Text>
    </button>
  );

  const renderItem = () => {
    /** it is possible for optional fields to send "" (empty string) to bypass axios default behavior of removing keys with undefined values */
    if (typeof value === "undefined" || value === "default" || value?.length === 0) {
      return (
        <Upload
          name="avatar"
          listType="picture-card"
          showUploadList={false}
          beforeUpload={beforeUpload}
          customRequest={({ file }) => {
            handleUpload(file);
          }}
          className={styles.file_upload}
        >
          {uploadButton}
        </Upload>
      );
    } else {
      const renderAsset = () => {
        if (fileType === "image") {
          return <Image src={getDriveUrl(value)} style={{ width: "100%" }} />;
        } else if (fileType === "video") {
          return (
            // Todo: better video preview
            // <Image
            //   // src={getDriveUrl(value)}

            //   preview={{
            //     imageRender: () => <video controls muted={false} src={getDriveUrl(value)} />,
            //   }}
            // />
            <video controls muted={false} src={getDriveUrl(value)} />
          );
        }
      };
      return (
        <div className={styles.change_card}>
          {renderAsset()}
          <div className={styles.change_delete_container}>
            <Upload
              name="avatar"
              showUploadList={false}
              beforeUpload={beforeUpload}
              customRequest={({ file }) => {
                handleUpload(file);
              }}
              // className={styles.file_upload}
            >
              <Button size="small" className={styles.btn} icon={<TbEdit />}>
                Edit
              </Button>
            </Upload>
            <Button
              onClick={() => {
                onChange?.(undefined);
              }}
              size="small"
              className={styles.btn}
              danger
              icon={<TbTrash />}
            >
              Delete
            </Button>
          </div>
        </div>
      );
    }
  };

  return <div>{renderItem()}</div>;
}
